import axios from 'axios';
import { getAuthToken, refreshAuthToken, setAuthToken, clearAuthData } from '@/utilsAuth';
import NProgress from 'nprogress';
import Vue from 'vue';

import 'nprogress/nprogress.css';

const apiClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      if (!config.url.includes('/notification')) {
        NProgress.start();
      }
    }
    return config;
  },
  (error) => {
    NProgress.done();
  
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

      if (error.response?.status === 400) {
        const msg = error.response.data?.message || 'Une erreur est survenue.';
        Vue.prototype.$snotify.error(msg);
      }


    if (error.response?.status === 401 && !originalRequest._retry) {

      if (!isRefreshing) {
        isRefreshing = true;
        originalRequest._retry = true;

        try {
          const newToken = await refreshAuthToken();
          setAuthToken(newToken);
          apiClient.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
          processQueue(null, newToken);
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          return apiClient(originalRequest);
        } catch (refreshError) {
          clearAuthData();
          processQueue(refreshError, null);
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      } else {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((newToken) => {
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return apiClient(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }
    }

    if (error.response?.status === 403) {
        clearAuthData();
        window.location.href = '/login';
    }


    NProgress.done();
    return Promise.reject(error);
  }
);

export default apiClient;